/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Export_Power_Point_Options_Extended_DescriptionInputs */

const en_export_power_point_options_extended_description = /** @type {(inputs: Export_Power_Point_Options_Extended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extended export with additional information such as key figures and comment details`)
};

const de_export_power_point_options_extended_description = /** @type {(inputs: Export_Power_Point_Options_Extended_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterter Export mit zusätzlichen Informationen wie zum Beispiel Kennzahlen- und Kommentardetails`)
};

/**
* | output |
* | --- |
* | "Extended export with additional information such as key figures and comment details" |
*
* @param {Export_Power_Point_Options_Extended_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const export_power_point_options_extended_description = /** @type {((inputs?: Export_Power_Point_Options_Extended_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Export_Power_Point_Options_Extended_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_export_power_point_options_extended_description(inputs)
	return de_export_power_point_options_extended_description(inputs)
});